module.exports = __webpack_public_path__ + "img/pin_green_camion.262daf56.svg";